/* eslint-disable @typescript-eslint/no-explicit-any */

import {isArray, isObject} from 'lodash';

const isMatchingShape = (value: unknown, keys: Array<string>) => {
    if (!isObject(value)) return false;

    const objectKeys = Object.keys(value);

    for (const index in objectKeys) {
        if (!keys.includes(objectKeys[index])) return false;
    }

    return true;
};

const looksLikeFieldErrorEntry = (value: unknown) => {
    if (isArray(value)) {
        if (value.length === 1 && typeof value[0] === 'string') return true;
        if (
            value.length === 1 &&
            isArray(value[0]) &&
            typeof value[0][0] === 'string'
        )
            return true;

        if (
            value.length === 1 &&
            typeof value[0] === 'object' &&
            typeof value[0].message === 'string'
        )
            return true;
    }

    return false;
};

const looksLikeFieldErrorObject = (value: unknown) => {
    try {
        const valueForcefullyTyped = value as Record<string, unknown>;
        const keys = Object.keys(valueForcefullyTyped);

        return keys.every((key) =>
            looksLikeFieldErrorEntry(valueForcefullyTyped[key]),
        );
    } catch {
        return false;
    }
};

export type DuckTypeMatchResponseReturnType = {
    data: any;
    message: string;
    status: number;
};

/*
Kind of duck-typing the correct data into the correct shape
*/
type DuckTypeMatchProps = {
    json?: any;
    status: number;
};

const DuckTypeMatchResponse = (
    props: DuckTypeMatchProps,
): DuckTypeMatchResponseReturnType => {
    let message = `Error "${props.status || 'Unknown Status Code'}"`;
    let data;

    /*
    Field Error
    */
    if (looksLikeFieldErrorObject(props.json?.response)) {
        message = 'Field Errors';
        data = props.json?.response;
    }

    /*
    4## - shape-1
    */
    if (props.json?.status === 'Error' && props.json?.message) {
        message = props.json?.message;
        data = undefined;
    }

    /*
    4## - shape-2
    */
    if (
        typeof props.json?.response.detail === 'string' &&
        isMatchingShape(props.json?.response, ['detail'])
    ) {
        message = props.json?.response.detail;
        data = undefined;
    }

    /*
    4## - shape-3
    */
    if (typeof props.json?.response === 'string') {
        message = props.json?.response;
        data = undefined;
    }

    /*
    4## - shape-4
    */
    if (typeof props.json?.response.message === 'string') {
        message = props.json?.response.message;
        data = undefined;
    }

    return {data, message, status: props.status};
};

export default DuckTypeMatchResponse;
